import type { CalendarEventType } from "../../../../types/api";

/**
 * Single source of truth for the USER-FACING label of a calendar event type.
 *
 * IMPORTANT: this maps DISPLAY text only. The enum value `Tournament` is unchanged everywhere in
 * code and the database (it drives games/weather/assignment and a DB CHECK constraint). We show it
 * as "Event" because a tournament and a showcase are the same thing to a coach. Never rename the
 * enum value or the `eventType === "Tournament"` comparisons — only the strings below.
 */
export const EVENT_TYPE_LABEL: Record<CalendarEventType, string> = {
  Tournament: "Event",
  RecruitVisit: "Recruit visit",
  OneOff: "One-off",
};

export const EVENT_TYPE_EMOJI: Record<CalendarEventType, string> = {
  Tournament: "🏆",
  RecruitVisit: "📍",
  OneOff: "📌",
};

export const eventTypeLabel = (type: CalendarEventType): string => EVENT_TYPE_LABEL[type];

export const eventTypeLabelWithEmoji = (type: CalendarEventType): string =>
  `${EVENT_TYPE_EMOJI[type]} ${EVENT_TYPE_LABEL[type]}`;
